import { useEffect } from 'react';
import { useStorage } from 'master-hook';
import { STORAGE_NAME } from './constants';
var AUTH_SYNC_CHANNEL = 'iomart-auth-sync';
function hasBroadcastChannel() {
    return typeof BroadcastChannel !== 'undefined';
}
/**
 * Broadcast new tokens to other tabs after relogin.
 * Other tabs will update their auth state so requests don't fail with stale tokens.
 */
export function broadcastTokensUpdated(access_token, refresh_token) {
    if (!hasBroadcastChannel())
        return;
    try {
        var channel = new BroadcastChannel(AUTH_SYNC_CHANNEL);
        channel.postMessage({ type: 'auth-tokens-updated', access_token: access_token, refresh_token: refresh_token });
        channel.close();
    }
    catch (_a) {
        // ignore
    }
}
/**
 * Subscribe to token updates from other tabs (e.g. when another tab does relogin).
 * Keeps this tab's tokens in sync so API requests succeed.
 */
export function useAuthTabSync() {
    var _a = useStorage(STORAGE_NAME), setAccessToken = _a.setAccessToken, setRefreshToken = _a.setRefreshToken;
    useEffect(function () {
        if (!hasBroadcastChannel())
            return undefined;
        var channel = new BroadcastChannel(AUTH_SYNC_CHANNEL);
        var handler = function (event) {
            var data = event === null || event === void 0 ? void 0 : event.data;
            if ((data === null || data === void 0 ? void 0 : data.type) === 'auth-tokens-updated' && (data === null || data === void 0 ? void 0 : data.access_token) && (data === null || data === void 0 ? void 0 : data.refresh_token)) {
                setAccessToken(data.access_token);
                setRefreshToken(data.refresh_token);
            }
        };
        channel.addEventListener('message', handler);
        return function () {
            channel.removeEventListener('message', handler);
            channel.close();
        };
    }, [setAccessToken, setRefreshToken]);
}
